module.exports = __webpack_public_path__ + "img/back.da2ae811.jpg";